module.exports = __webpack_public_path__ + "static/media/vitaminc1.5aad5648.pdf";